import React, { Component } from 'react';
import Rtiles from 'components/Rtiles';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { is } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import Divider from 'components/Divider';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import Loader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component

import styles from './Requests.scss';// to import local scss fle

class Requests extends Component {
  static propTypes = {
    attributes: PropTypes.shape(),
    getAllRequests: PropTypes.func,
    allRequests: PropTypes.shape(),
    requestLoaded: PropTypes.bool,
    conversationUpdated: PropTypes.bool,
    profile: PropTypes.shape(),
  };

  static defaultProps= {
    attributes: {},
    getAllRequests: () => {},
    allRequests: {},
    requestLoaded: false,
    conversationUpdated: false,
    profile: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  componentWillMount() {
    if (this.props.attributes.size > 0 && this.props.profile.size > 0) {
      const id = this.props.profile.get('college_id');
      this.props.getAllRequests(id);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.profile.size > 0 && is(this.props.allRequests, nextProps.allRequests)
        && !nextProps.requestLoaded && !nextProps.conversationUpdated &&
      !nextProps.allRequests.size > 0) {
      const id = nextProps.profile.get('college_id');
      this.props.getAllRequests(id);
    } else if (nextProps.conversationUpdated) {
      const id = nextProps.profile.get('college_id');
      this.props.getAllRequests(id);
    }
  }

  render() {
    const renderLoader = renderIf(!this.props.requestLoaded || this.props.conversationUpdated);
    const renderRequests = renderIf(this.props.requestLoaded);
    let toProfileId = [];
    let fromProfileId = [];
    let noToProfileId = true;
    let noFromProfileId = true;
    if (this.props.allRequests && this.props.allRequests.size > 0) {
      toProfileId = this.props.allRequests;
      fromProfileId = []; // udate this when you want to show tiles, when coach made any request
      if (this.props.allRequests.size > 0) {
        noToProfileId = false;
      }
      if (fromProfileId.length > 0) { // udate this when you want to show tiles,
                                    // when coach made any request
        noFromProfileId = false;
      }
    }
    const renderNoToProfileId = renderIf(noToProfileId || !this.props.requestLoaded);
    const renderNoFromProfileId = renderIf(noFromProfileId);
    return (
      <div>
        {renderLoader(
          <Loader />,
        )}
        <div className={cn('row', styles.container)} />
        {renderRequests(
          <div className={styles.container}>
            <div className={styles.fromToContainer}>
              <span className={styles.studentShowedInterest}>
                STUDENTS WHO HAVE SHOWN INTEREST IN YOUR PROGRAM.
              </span>
              <Divider />
              {renderNoToProfileId(
                <div className={cn('col s12', styles.adaptContainer)}>
                  <div className={styles.emptyImage}>
                    <img src="https://media.dev.myrecruitboard.com/Images/no-content-found%403x.png" alt="empty screen" />
                  </div>
                  {/* <div className={styles.noDescFound}>
                      No content found.
                    </div> */}
                </div>,
                )}
              {toProfileId.map(item => (
                <Rtiles {...this.props} item={item} />
            ))}
            </div>
            {fromProfileId.size > 0 ?
              <div className={styles.fromToContainer}>
                <span className={styles.studentShowedInterest}>
                 Student whom you showed interest.
             </span>
                <Divider />
                {renderNoFromProfileId(
                  <div className={cn('col s12', styles.adaptContainer)}>
                    <div className={styles.emptyImage}>
                      <img src="https://media.dev.myrecruitboard.com/Images/no-content-found%403x.png" alt="empty screen" />
                    </div>
                    {/* <div className={styles.noDescFound}>
                      No content found.
                    </div> */}
                  </div>,
                )}
                {fromProfileId.map(item => (
                  <Rtiles {...this.props} item={item} />
                ))}
              </div> : ''}
          </div>,
         )}
      </div>
    );
  }
}

export default Requests;



// WEBPACK FOOTER //
// ./src/components/Requests/Requests.js